module.exports = __webpack_public_path__ + "img/new_30.80d0bd58.jpg";